import { Box, Typography } from '@mui/material';
import { parametersDisplayStyles } from './styles';

interface ParametersDisplayProps {
  params: Record<string, any> | undefined;
}

export const ParametersDisplay = ({ params }: ParametersDisplayProps) => {
  if (!params) {
    return (
      <Typography variant="body2" color="text.secondary">
        -
      </Typography>
    );
  }

  try {
    const paramText = JSON.stringify(params, null, 2);

    return (
      <Box>
        <Typography variant="body2" sx={parametersDisplayStyles}>
          {paramText}
        </Typography>
      </Box>
    );
  } catch {
    return (
      <Typography variant="body2" sx={parametersDisplayStyles}>
        {String(params)}
      </Typography>
    );
  }
};
